export default {"src":"/_next/static/media/play.ae9a3ef9.svg","height":13,"width":11,"blurWidth":0,"blurHeight":0};